import { render, staticRenderFns } from "./TweetDetail.vue?vue&type=template&id=5f6d1e5a&scoped=true&"
import script from "./TweetDetail.vue?vue&type=script&lang=js&"
export * from "./TweetDetail.vue?vue&type=script&lang=js&"
import style0 from "./TweetDetail.vue?vue&type=style&index=0&id=5f6d1e5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6d1e5a",
  null
  
)

export default component.exports